// extracted by mini-css-extract-plugin
export default {"expendBox":"Point__expendBox___SZiI8","expendBtn":"Point__expendBtn___DUwL2"};